import { promises as fs } from 'fs'
import path from 'path'
import { NextActionSchema, type NextAction } from '../../domain/view-models'

/**
 * Repository that reads Next Actions from markdown files.
 */
export class NextActionsFileRepository {
  private readonly dir: string

  constructor(gtdDir?: string) {
    const fsRoot = process.env.GTD_FILE_SYSTEM || path.resolve(process.cwd(), '..', '.gtd')
    this.dir = gtdDir ?? path.join(fsRoot, 'next-actions')
  }

  async getNextActions(): Promise<NextAction[]> {
    let files: string[]
    try {
      files = await fs.readdir(this.dir)
    } catch {
      return []
    }
    const actions: NextAction[] = []
    for (const file of files.filter(f => f.endsWith('.md'))) {
      const category = file.replace(/\.md$/, '')
      const filePath = path.join(this.dir, file)
      const stats = await fs.stat(filePath)
      const content = await fs.readFile(filePath, 'utf-8')
      const lines = content.split(/\r?\n/)
      for (let idx = 0; idx < lines.length; idx++) {
        const match = lines[idx].match(/^- \[( |x)\] (.*)$/)
        if (!match) continue
        const done = match[1] === 'x'
        const text = match[2].trim()
        const id = `${category}-${idx}`
        const action = NextActionSchema.parse({
          id,
          text,
          done,
          category,
          fileName: file,
          fileCreatedAt: stats.birthtime.toISOString(),
          fileModifiedAt: stats.mtime.toISOString(),
          fileSize: stats.size,
          lineNumber: idx + 1,
        })
        actions.push(action)
      }
    }
    return actions
  }
}